import React, { useState } from 'react';
import { toast } from 'react-toastify';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [telegramHandle, setTelegramHandle] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const MAX_CHARS = 1000;

  // Identifiants EmailJS
  const SERVICE_ID = 'service_28t4ioi';
  const TEMPLATE_ID = 'template_ahcoa85';
  const PUBLIC_KEY = 'leOFWn0jZgJ9dHbZl';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Simple validation
    if (!fullName || !email || !message) {
      toast.error('Please fill in all required fields');
      return;
    }

    if (!email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    // Validation de la longueur du message
    if (message.length > MAX_CHARS) {
      toast.error(`Your message exceeds the maximum limit of ${MAX_CHARS} characters`);
      return;
    }

    setIsSubmitting(true);

    try {
      // Préparer les paramètres pour le template
      const templateParams = {
        name: fullName,
        email: email,
        telegram: telegramHandle || 'Not provided',
        message: message,
        to_email: 'contact@flashback.tech',
      };

      // Envoyer l'email via EmailJS
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);

      // Reset the form
      setFullName('');
      setEmail('');
      setTelegramHandle('');
      setMessage('');
      setCharCount(0);

      toast.success('Your message has been sent successfully');
    } catch (error) {
      toast.error('An error occurred while sending your message');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col flex-1 bg-white">
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        {/* Contact form card */}
        <div id="contact6_form" className="w-full max-w-md bg-[#1e293b] rounded-3xl p-8 text-white">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="fullName" className="block text-sm font-medium mb-2">
                Full name*
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                className="w-full px-4 py-3 rounded-full bg-white text-gray-800 focus:outline-none"
                placeholder="Your full name"
                required
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2">
                Email address*
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-full bg-white text-gray-800 focus:outline-none"
                placeholder="Email address"
                required
              />
            </div>

            <div>
              <label htmlFor="telegram" className="block text-sm font-medium mb-2">
                Telegram handle
              </label>
              <input
                type="text"
                id="telegram"
                name="telegram"
                value={telegramHandle}
                onChange={(e) => setTelegramHandle(e.target.value)}
                className="w-full px-4 py-3 rounded-full bg-white text-gray-800 focus:outline-none"
                placeholder="@example"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium mb-2">
                Anything you would like to add?*
              </label>
              <textarea
                id="message"
                name="message"
                value={message}
                onChange={(e) => {
                  const input = e.target.value;
                  if (input.length <= MAX_CHARS) {
                    setMessage(input);
                    setCharCount(input.length);
                  }
                }}
                maxLength={MAX_CHARS}
                rows={5}
                className="w-full px-4 py-3 rounded-xl bg-white text-gray-800 focus:outline-none"
                placeholder="Start typing"
                required
              />
              <div className="flex justify-end mt-1 text-sm text-gray-300">
                <span className={charCount > MAX_CHARS * 0.9 ? 'text-orange-300' : ''}>
                  {charCount}/{MAX_CHARS} characters
                </span>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#6366f1] hover:bg-[#4f46e5] text-white py-3 px-4 rounded-full font-medium transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'SENDING...' : 'SUBMIT'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
